import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../components/global/modal/withModal';
import MountingIcon from '../../../../../../components/icons/MountingIcon';
import Badge from '../../../../../../components/global/Badge';
import PriceDisplay from '../../../../../../components/global/PriceDisplay';
import CustomControl from '../../../../../../components/global/CustomControl';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  className: PropTypes.string,
  printProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  selectedPrintProductSize: PropTypes.shape({
    id: PropTypes.string.isRequired,
    mounts: PropTypes.shape({
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          print_mount: PropTypes.shape({
            name: PropTypes.string.isRequired,
          }).isRequired,
          price: PropTypes.object.isRequired,
        }).isRequired,
      ),
    }).isRequired,
  }).isRequired,
  selectedPrintProductMount: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  handlePrintProductMountSelect: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

const PrintProductMountingOptionsAlertModal = ({
  className,
  selectedPrintProductSize,
  selectedPrintProductMount,
  handlePrintProductMountSelect,
  onComplete,
  onRequestClose,
}) => {
  const classes = classNames({
    'print-product-mounting-options-alert': true,
    [className]: !!className,
  });
  const printProductSizeMounts = selectedPrintProductSize?.mounts;

  return (
    <div className={classes}>
      <div className="print-product-mounting-options-alert-header">
        <span className="print-product-mounting-options-alert-header-icon">
          <MountingIcon />
        </span>
        <h4>Mounting Options</h4>
      </div>

      <p className="text-sm">
        Due to the size of this artwork, a mounting option is highly
        recommended.
      </p>

      <div className="print-product-mounting-options-alert-mounts-list">
        {printProductSizeMounts.records.map(printProductSizeMount => {
          const isSelected =
            selectedPrintProductMount?.id === printProductSizeMount.id;

          return (
            <a
              key={printProductSizeMount.id}
              href="#"
              onClick={event => {
                event.preventDefault();
                handlePrintProductMountSelect(printProductSizeMount.id);
              }}
              className={classNames({
                'print-product-mounting-options-alert-mount': true,
                'is-selected': isSelected,
              })}
            >
              <CustomControl
                type="checkbox"
                checked={isSelected}
                readOnly
                className="pointer-events-none"
              />
              {printProductSizeMount.print_mount.name}
              <Badge badgeStyle="yellow" className="text-extra-bold">
                <PriceDisplay
                  price={printProductSizeMount.price.value}
                  currency={printProductSizeMount.price.currency}
                />
              </Badge>
            </a>
          );
        })}

        <Button
          btnBlock
          btnSize="lg"
          onClick={() => {
            onRequestClose();
            onComplete();
          }}
          btnStyle={selectedPrintProductMount ? 'success-vibrant' : 'primary'}
          className="mt-3"
        >
          {selectedPrintProductMount ? 'Add and continue' : 'No thanks'}
        </Button>
      </div>
    </div>
  );
};

PrintProductMountingOptionsAlertModal.propTypes = propTypes;

export const PRINT_PRODUCT_MOUNTING_OPTIONS_ALERT_MODAL =
  'PRINT_PRODUCT_MOUNTING_OPTIONS_ALERT_MODAL';

export default withModal(PrintProductMountingOptionsAlertModal, {
  name: PRINT_PRODUCT_MOUNTING_OPTIONS_ALERT_MODAL,
  dismissible: false,
  hideHeader: true,
  size: 'sm',
  className: 'print-product-mounting-options-alert-modal',
});
